import {
  Comparator,
  ComparatorResult,
  ComparatorResultMutator,
} from '@qality/common-model/src/sorting/Comparator';

const compareStrings: Comparator<string> = (a, b) => {
  return a.localeCompare(b);
};

const compareNumbers: Comparator<number> = (a, b) => {
  return a - b;
};

const reverseComparatorResult: ComparatorResultMutator = (
  value: ComparatorResult
) => {
  return value * -1;
};

export default { compareNumbers, compareStrings, reverseComparatorResult };
